
import { locale } from './globals.js';
import { loadJSON, eventOptionSupport as eos } from './toolbox.js';
import eventPopup from './event-popup';

let oneoffEvents = eos('once');

const defaultApi = '/assets/data/events.json';

const todayISOstring = moment(new Date()).format().split('T')[0];
const today = new Date(todayISOstring);

const monthSeparator = function (date) {
  return `<li class="event-month-divider">${date}</li>`
}
const eventThumb = function (event) {
  let url = event.url;
  let isToday = (event.day == today.getDate()) ? 'is-today' : '';
  let isPast = event.past ? 'is-past' : '';
  let lastDateEntry = event.days[event.days.length - 1];
  let lastDateEntrySplit = lastDateEntry.split(' ');
  let comma = (locale.lang == "ar") ? '، ' : ',';

  
  // only add locale if it's not present already
  if (url.indexOf(`/${locale.lang}/`) === -1 ) url = `/${locale.lang}${event.url}`;

  return `
    <li> <a href="${url}" class="event-thumb box landscape ${isPast} ${isToday}" data-event-popup>
      <div class="box-thumb"> <div class="day">${event.dateDisplay.day}</div> <div class="month">${event.dateDisplay.month}</div> </div>
      <div class="box-cover"> <figure class="cover aspect-ratio wide hover-zoom" style="background-image:url('${event.thumb}')"></figure> </div>
      <div class="box-content"> <div class="wrap">
        <h3 class="box-title">${event.title}</h3>
        <div class="event-dates">${event.days.join(`${comma} `)} ${(lastDateEntrySplit[lastDateEntrySplit.length - 1].length <= 2) ? event.dateDisplay.month : ''}</div>
      </div> </div>
    </a> </li>
    `
}
const peekView = function (events, date) {
  let peek = document.createElement('div');
  peek.classList.add('day-peek');
  peek.innerHTML += `<div class="date">${date}</div>`;
  events.forEach((event) => {
    let url = event.url;
    if (url.indexOf(`/${locale.lang}/`) === -1 ) url = `/${locale.lang}${event.url}`;
    peek.innerHTML += `<a href="${url}" class="event-title" data-event-popup>${event.title}</a>`;
  })
  return peek;
}
const emptyThumb = function (msg) {
  return `
    <li class="no-events">${msg}</li>
    `
}

class EventBrowser {
  constructor (el) {
    if(!el) return false;
    this.el = el;
    this.list = this.el.querySelector('[data-event-list]');
    this.api = this.el.getAttribute('data-event-api') ? this.el.getAttribute('data-event-api') : defaultApi;
    let calendarArrows = ['◀', '▶'];
    //if (locale.dir == 'rtl') calendarArrows = ['▶', '◀'];
    try { HelloWeek } catch { return; }
    this.helloWeek = new HelloWeek({
      langFolder: '/assets/lib/hello-week/langs/',
      weekStart: 0,
      disablePastDays: true,
      onNavigation: this.update.bind(this),
      // onSelect: this.daySelected.bind(this),
      nav: calendarArrows,
      rtl: (locale.dir == 'rtl'),
      lang: locale.lang
    });
    loadJSON(this.api, (data) => {
      this.data = JSON.parse(data);
      requestAnimationFrame(() => {
        this.highlightCalendar();
        this.update();
      })
    }, (resp) => {});
    this.el.querySelector('[data-event-nav="next-month"]').addEventListener('click', () => {this.helloWeek.next()});
    this.helloWeek.calendar.month.addEventListener('click', this.peekingHandler.bind(this));
    window.addEventListener('click', () => {
      if(this.peeking) this.peekingClose();
    })
  }
  peekingHandler(event) {
    event.stopPropagation();
    if (event.target.hasAttribute('data-event-popup')) return;
    
    if (this.peeking) this.peekingClose();
    if (event.target.hasAttribute('data-events')) {
      requestAnimationFrame(() => {
        this.peeking = true;
        event.target.classList.add('peeking');
      })
    }
  }
  peekingClose() {
    this.peeking = false;
    Array.from(this.helloWeek.calendar.month.querySelectorAll('.peeking')).forEach((day) => {
      day.classList.remove('peeking');
    })
  }
  calendarMarkers() {
    let days = Array.from(this.helloWeek.calendar.month.children)
    let month = new Array(days.length);
    this.entries.forEach((event) => {
      days[event.day - 1].classList.add('is-highlight');
      //this.addEventToDay(days[event.day - 1], event.id);
      addToMonth(event.day - 1, event.id);
      
      if (event.dayLast) {
        for (let d = event.day; d < event.dayLast; d++) {
          days[d].classList.add('is-highlight');
          addToMonth(d, event.id);
        }
      }
    })
    function addToMonth(index, id) {
      if (month[index]) month[index].push(id)
      else month[index] = [`${id}`];
    }
    days.forEach((day, index) => {
      if(month[index]) {
        day.setAttribute('data-events', month[index].join(','));
        let eventsToday = [];
        let titles = [];
        month[index].forEach((id) => {
          let event = this.uniqueEntries.find((e) => {
            return e.id == id;
          })
          if (event) {
            eventsToday.push(event);
            titles.push(event.title);
          }
        })
        day.setAttribute('title', titles.join(', '));
        let date = `${index+1} ${eventsToday[0].dateDisplay.month}`
        day.appendChild(peekView(eventsToday, date));
      }
    })
  }

  highlightCalendar() {
    let calendarEvents = [];
    this.data.forEach((event) => {
      calendarEvents.push(
        {
          days: event.dates,
          title: event.title[locale.lang]
        }
      )
    })
    this.helloWeek.update();
  }
  normalizeDates() {
    this.data.forEach((event, e) => {
      let hasRange = false;
      this.data[e].dates.some((date) => {
        if(Array.isArray(date)) {
          hasRange = true;
        }
      })
      if (hasRange) {
        this.data[e].dates.forEach((date, d) => {
          if(!Array.isArray(date)) this.data[e].dates[d] = [date, date];
        })
      }
    });
  }
  update() {
    this.updateEntries();
    this.createUniqueEntries();
    this.calendarMarkers();
    this.sortUniqueEntries();
    this.pastRestictions();
    requestAnimationFrame(() => {
      // if (this.preventListUpdate) return;
      this.updateList();
      requestAnimationFrame(() => {
        eventPopup();
      })
    })
  }
  updateEntries() {
    this.entries = [];

    //console.log(moment([this.helloWeek.getYear(), this.helloWeek.getMonth() - 1]).endOf('month').format('D'));
    this.data.forEach((event, e) => {
      event.dates.forEach((date, d) => {
        let dateStart, dateEnd;
        let isCurrent = false;
        let isPast = false;
        let sortDay = 1;
        let closeDay = undefined;
        let calendarDate = moment([this.helloWeek.getYear(), this.helloWeek.getMonth() - 1]);

        
        if (Array.isArray(date)) dateStart = new Date(date[0]);
        else dateStart = new Date(date);

        if(moment(dateStart).isBefore(today)) isPast = true;

        if (Array.isArray(date) && date[0] != date[1] ) {
          dateEnd = new Date(date[1]);
          
          if(moment(dateEnd).isBefore(today)) isPast = true;
          else isPast = false;

          if (this.helloWeek.getYear() === dateStart.getFullYear()) {
            if (this.helloWeek.getMonth() === dateStart.getMonth() + 1) {
              // starts this month
              isCurrent = true;
              sortDay = dateStart.getDate();
              if (this.helloWeek.getMonth() === dateEnd.getMonth() + 1) {
                // starts and ends this month
                closeDay = dateEnd.getDate();
              } else {
                // starts this month and ends later
                closeDay = moment([this.helloWeek.getYear(), this.helloWeek.getMonth() - 1]).endOf('month').format('D');
              }
            } else {
              if (this.helloWeek.getMonth() === dateEnd.getMonth() + 1) {
                // starts earlier and ends this month
                isCurrent = true;
                closeDay = dateEnd.getDate();
              } else {
                if (calendarDate.startOf('month').isAfter(dateStart) && calendarDate.endOf('month').isBefore(dateEnd)) {
                  // starts earlier and ends later
                  closeDay = moment([this.helloWeek.getYear(), this.helloWeek.getMonth() - 1]).endOf('month').format('D');
                  isCurrent = true;
                }
              }
            }
          } else if (this.helloWeek.getYear() === dateEnd.getFullYear()) {
            if (this.helloWeek.getMonth() === dateEnd.getMonth() + 1) {
              isCurrent = true;
              closeDay = dateEnd.getDate();
            }
          }
        } else {
          if (this.helloWeek.getYear() === dateStart.getFullYear()) {
            if (this.helloWeek.getMonth() === dateStart.getMonth() + 1) {
              isCurrent = true;
              sortDay = dateStart.getDate();
            }
          }
        }

        if (isCurrent) {

          this.entries.push({
            id: event.id,
            day: sortDay,
            dayLast: closeDay,
            past: isPast,
            dateDisplay: {
              day: moment(dateStart).format('DD'),
              month: moment(dateStart).format('MMM')
            },
            dates: event.dates,
            currentDates: (dateEnd) ? [dateStart, dateEnd] : [dateStart],
            title: event.title[locale.lang],
            thumb: event.thumb,
            url: event.url
          })
        }
      })
    })
    this.entries.sort((a, b) => (a.day - b.day) );
    
  }
  createUniqueEntries() {
    let ids = [];
    let calendarDate = moment([this.helloWeek.getYear(), this.helloWeek.getMonth() - 1]);
    this.uniqueEntries = this.entries.filter((event, index, self) => {
      ids.push(event.id);
      return ids.indexOf(event.id) == index;
    })
    this.uniqueEntries.forEach((uev) => {
      uev.days = [];
      this.entries.forEach((ev) => {
        if (ev.id == uev.id) {
          if(ev.dayLast) {
            if (calendarDate.startOf('month').isAfter(ev.currentDates[0])) {
              //console.log(ev.title, calendarDate.format("D MMM"), moment(ev.currentDates[0]).format("D MMM"));
              // starts earlier
              uev.days.push(`${moment(ev.currentDates[0]).format("D MMM")} – ${moment(ev.currentDates[1]).format("D MMM")}`);
            } else {
              // starts this month

              if (calendarDate.endOf('month').isBefore(ev.currentDates[1])) {
                // starts this month and ends later
                uev.days.push(`${moment(ev.currentDates[0]).format("D MMM")} – ${moment(ev.currentDates[1]).format("D MMM")}`);
              } else {
                // starts and ends this month
                uev.days.push(`${ev.day} – ${ev.dayLast}`);
              }
            }

          } else {
            uev.days.push(`${ev.day}`);
          }
        }
      })
    });
    
  }
  sortUniqueEntries() {
    this.uniqueEntries.forEach((uev) => {
      this.entries.forEach((ev) => {
        if (ev.id == uev.id) {
          if(uev.past && !ev.past) {
            uev.past = false;
            if(ev.dayLast) {
              if (ev.day > today.getDate()) {
                uev.day = ev.day;
                uev.dateDisplay.day = moment(ev.currentDates[0]).format('DD');
              } else {
                uev.day = today.getDate();
                uev.dateDisplay.day = moment(today).format('DD');
              }
              
            } else {
              uev.day = ev.day;
              uev.dateDisplay.day = moment(ev.currentDates[0]).format('DD');
            }
          }
        }
      })
    });
    this.uniqueEntries.sort((a, b) => (a.day - b.day) );
  }
  pastRestictions() {
    // hide list items from the past
    this.hidePastEntries = true;
    // get current calendar date
    let calendarDate = moment([this.helloWeek.getYear(), this.helloWeek.getMonth() - 1]);
    if (calendarDate.endOf('month').isBefore(today)) {
      this.preventListUpdate = true;
    } else {
      this.preventListUpdate = false;
    }
    // prevent calendar from navigating to past months
    /* if (moment(today).startOf('month').isSame(calendarDate.startOf('month')) || calendarDate.endOf('month').isBefore(today)) {
      this.helloWeek.calendar.prevMonth.classList.add('past');
    } else {
      this.helloWeek.calendar.prevMonth.classList.remove('past');
    } */
  }
  updateList () {
    if (this.preventListUpdate) return;
    let msg = '';
    let dom = '';
    let month = (this.helloWeek.getMonth() > 9) ? this.helloWeek.getMonth() : '0'+this.helloWeek.getMonth();
    let title = moment(`${this.helloWeek.getYear()}-${month}-01`).format('MMMM YYYY');
    let entries = this.uniqueEntries;
    dom += monthSeparator(title);
    if (entries && entries.length > 0) {
      entries.forEach(event => {
        if(event.past && this.hidePastEntries) return;
        dom += eventThumb(event);
      });
    } else {
      msg = this.list.getAttribute('data-event-empty') ? this.list.getAttribute('data-event-empty') : 'No events';
      dom += emptyThumb(msg);
    }
    requestAnimationFrame(() => {
      this.list.innerHTML = dom;
    })
  }
}
export default function () {
  new EventBrowser(document.querySelector('[data-event-browser]'));
}
